import { render, staticRenderFns } from "./WalletHeader.vue?vue&type=template&id=691f9794&scoped=true&lang=pug"
import script from "./WalletHeader.vue?vue&type=script&lang=js"
export * from "./WalletHeader.vue?vue&type=script&lang=js"
import style0 from "./WalletHeader.vue?vue&type=style&index=0&id=691f9794&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691f9794",
  null
  
)

export default component.exports